<form class="mce-form-section">


    <div class="mce-form-field-group">

        <div>
            <mat-form-field>
                <mat-label>burried depth</mat-label>
                <input matInput type="number" placeholder="buried depth"
                       [formField]="form().depth" />
                <span matSuffix>m</span>
                @for (error of form().depth().errors(); track error.kind ) {
                <mat-error> {{ error.message }} </mat-error> }
            </mat-form-field>
        </div>

        <div>
            <mat-form-field>
                <mat-label>soil thermal resistivity</mat-label>
                <input matInput type="number" placeholder="soil thermal resistivity"
                       [formField]="form().soilThermalResistivity" />
                <span matSuffix>K.m/W</span>
                @for (error of form().soilThermalResistivity            ().errors(); track error.kind ) {
                <mat-error> {{ error.message }} </mat-error> }
            </mat-form-field>
        </div>


    </div>

</form>
